export default __webpack_public_path__ + "static/cover-59f62d2275bd168aeb510a89484b1336.png";